;(function () {

"use strict";

var MetafieldsFormView = require('../views/metafields-form');

var FormView = MetafieldsFormView.extend({
  deleteMetafield: function (e) {
    console.log('deleting metafield');
    var self = this;

    var $this = $(e.currentTarget);
    var id = $this.closest('.card-section').data('id');
    var key = $this.closest('.card-section').data('key');

    ShopifyApp.Modal.confirm({
      title: 'Delete Metafield Content',
      message: "Are you sure you want to delete the content in this metafield?",
      okButton: "Yes, delete this content",
      cancelButton: "No, keep this content",
      style: "danger"
    }, function (result) {

      if (result === true) {
        $.ajax({
          url: "/objects/"+id+'/'+key,
          type: 'DELETE',
          success: function (response) {
            console.log(response);
            window.location.reload();
          }
        });
      }
    });

    return false;
  }
})

var PageView = Backbone.View.extend({
  initialize: function () {
    var url = '/objects/' + window.data.type;

    var mfv = new FormView({ el: this.$el.find('form').first(), url: url});

    window.Buttons = {
      primary: {
        label: "Save Changes",
        message: 'metafields_form_submit',
        loading: true,
        callback: function (message, data) {
          window.App.Events.trigger('submit');
        }
      }
    };

    mfv.saved = function (d) {
      var target = d.target || d.srcElement;
      d = JSON.parse(target.responseText);

      if (d.status === 'error') {
        ShopifyApp.Modal.alert({
          title: "Oops, something isn't right",
          message: d.err
        });
      } else if (d.status !== 'success') {
        ShopifyApp.Modal.alert({
          title: d.err,
          message: 'Sorry, Something went wrong. Please try this action again or contact jason@thebestagency.com for more help.'
        });        
      } else {
        ShopifyApp.internalRedirect('/objects/upsert/' + window.data.type + '/' + d.object.id);
      }
      ShopifyApp.Bar.loadingOff();
    };

    console.log('init object upsert view');
  },
  events: {
    'click .delete-instance': function (e) {
      e.preventDefault();
      e.stopPropagation();

      var id = $('#object-id').data('id');

      ShopifyApp.Modal.confirm({
        title: 'Delete Object',
        message: "Are you sure you want to delete this object?",
        okButton: "Yes, delete this object",
        cancelButton: "No, keep this object",
        style: "danger"
      }, function (result) {

        if (result === true) {
          $.ajax({
            url: "/objects/"+id,
            type: 'DELETE',
            success: function (response) {
              console.log(response);
              ShopifyApp.internalRedirect('/objects/list');
            }
          });
        }
      });
    }
  }
});

module.exports = PageView;

}());